<style scoped>

</style>

<template>
  <div>
    无访问权限(401)
  </div>
</template>

<script>
export default {
  
}
</script>



// WEBPACK FOOTER //
// src/plugins/errorPage/401.vue